import { ApolloClient, HttpLink, InMemoryCache, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

import { getGraphqlUrl } from "config/graphql";

export function createGraphqlClient(chainId: number) {
  const httpLink = new HttpLink({ uri: getGraphqlUrl(chainId) });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      // eslint-disable-next-line no-console
      console.warn("GraphQL errors:", graphQLErrors);
    }
    if (networkError) {
      // eslint-disable-next-line no-console
      console.warn("GraphQL network error:", networkError);
    }
  });

  return new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "network-only",
        nextFetchPolicy: "cache-first",
        errorPolicy: "all",
      },
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });
}
